//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { getIsFacebookAppReview } from '@pinterest/redux/selectors/getIsFacebookAppReview';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export const HomeNav = () => {
  const isFacebookReview = useSelector(getIsFacebookAppReview);

  if (!isFacebookReview) {
    return null;
  }

  return (
    <NavMenuItem
      activeNavGroup={NavGroup.HOME}
      state='index'
      stateOptions={{ inherit: false }}
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.HOME_NAV}
    >
      Home
    </NavMenuItem>
  );
};
